import React, { useState } from 'react';
import question_icon from 'src/images/icon/question_icon.png';

interface FormFieldProps {
    label: string;
    name: string;
    type?: string;
    value?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    warning?: string;
    infoMessage?: string;
    placeholder?: string;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    error?: boolean;
    errorMessage?: string;
    showClearButton?: boolean;
    onClear?: () => void;
}

const FormField: React.FC<FormFieldProps> = ({
                                                 label,
                                                 name,
                                                 type = 'text',
                                                 value,
                                                 onChange,
                                                 className = 'form-field',
                                                 warning,
                                                 infoMessage,
                                                 placeholder,
                                                 onBlur,
                                                 error,
                                                 errorMessage,
                                                 showClearButton = false,
                                                 onClear
                                             }) => {
    const [showInfo, setShowInfo] = useState(false);

    return (
        <div className={className}>
            <div className="form-label-row">
                <label className="form-label">{label}</label>
                {infoMessage && (
                    <div
                        style={{ position: 'relative', display: 'inline-block' }}
                        onMouseEnter={() => setShowInfo(true)}
                        onMouseLeave={() => setShowInfo(false)}
                    >
                        <img
                            src={question_icon}
                            alt="Info"
                            className="question-icon"
                        />
                        {showInfo && (
                            <div
                                className="info-message tooltip"
                            >
                                {infoMessage}
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div className="form-input-wrapper">
                <input
                    type={type}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    className={`form-input ${error ? 'form-input-error' : ''} ${showClearButton ? 'form-input-with-clear' : ''}`}
                    placeholder={placeholder}
                />
                {showClearButton && value && (
                    <button
                        type="button"
                        className="clear-button"
                        onClick={onClear}
                    >
                        ✕
                    </button>
                )}
            </div>
            {warning && <div className="email-warning">{warning}</div>}
            {error && errorMessage && <div className="field-error">{errorMessage}</div>}
        </div>
    );
};

export default FormField;